import { FCWithChildren } from '@types';
import React from 'react';
import { Button, InputSectionGroup } from '@components';
import { useToasts } from 'react-toast-notifications';
import useLayoutContext from '@hooks/useLayoutContext';
import { MdWifi } from 'react-icons/md';
import { FaWifi } from 'react-icons/fa';

type OtherBodyProps = {
  preWiredKey?: string;
};

const OtherBody: FCWithChildren<OtherBodyProps> = ({ preWiredKey }) => {
  const { ssid } = useLayoutContext();
  const { addToast } = useToasts();

  return (
    <div className="flex gap-10 items-start">
      <div className="min-w-0 space-y-4 text-gray-700 dark:text-gray-300">
        <div className="flex gap-4 items-baseline">
          <span className="shrink-0 text-gray-400 dark:text-gray-500">1</span>
          <p>
            Find the MAC address of your device
            <br />
            <span className="text-sm text-gray-500 dark:text-gray-400">
              <b>Note:</b> Turn off Random or Private setting to get the static address
            </span>
          </p>
        </div>
        <div className="flex gap-4 items-baseline">
          <span className="shrink-0 text-gray-400 dark:text-gray-500">2</span>
          <p>
            Log into <b className="text-xl font-bold break-all">{window.location.host}</b> and click
            on <b className="text-xl">"Add Device"</b>
          </p>
        </div>
        <div className="flex gap-4 items-baseline">
          <span className="shrink-0 text-gray-400 dark:text-gray-500">3</span>
          <p>Select device type, then enter MAC address</p>
        </div>
        <div className="flex gap-4 items-baseline">
          <span className="shrink-0 text-gray-400 dark:text-gray-500">4</span>
          <div className="w-full">
            <p>After device is added, then go to that device and select network</p>
            <InputSectionGroup className="mt-2">
              <InputSectionGroup.Item>
                <div className="input-section-group__field">
                  <label className="flex gap-4 items-center">
                    <div className="bg-blue-500 rounded-full p-2">
                      <FaWifi className="text-2xl inline" />
                    </div>
                    {ssid}
                  </label>
                </div>
              </InputSectionGroup.Item>
            </InputSectionGroup>
          </div>
        </div>
        <div className="flex gap-4 items-baseline">
          <span className="shrink-0 text-gray-400 dark:text-gray-500">5</span>
          <div className="w-full">
            <p>Enter your WiFi Password/PSK for the network</p>
            <div className="flex gap-2 items-center mt-2">
              <InputSectionGroup>
                <InputSectionGroup.Item>
                  <div className="input-section-group__field">
                    <label className="flex gap-4 items-center">{preWiredKey}</label>
                  </div>
                </InputSectionGroup.Item>
              </InputSectionGroup>
              <div className="flex-1 items-center flex">
                <Button
                  onClick={() => {
                    navigator.clipboard.writeText(preWiredKey || '');
                    addToast('Wi-Fi password copied', { appearance: 'success' });
                  }}
                  size="small"
                >
                  Copy
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="flex gap-4 items-baseline">
          <span className="shrink-0 text-gray-400 dark:text-gray-500">6</span>
          <p>
            Select <b className="text-xl font-bold">"Auto-reconnect"</b> option for MyResNet
          </p>
        </div>
        <p className="pt-1 text-sm text-gray-500 dark:text-gray-400">
          Device registration is required for wired connections, as well.
        </p>
      </div>
    </div>
  );
};

export default OtherBody;
